import React, { useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function AddInventory() {
  const [userId, setUserId] = useState("");
  const [cityIds, setCityIds] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [userList, setUserList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Manage dropdown visibility
  const dropdownRef = useRef(null); // To handle clicks outside dropdown

  const [isDropdownLocationOpen, setIsDropdownLocationOpen] = useState(false);
  const dropdownLocationRef = useRef(null);
  const [locationIds, setLocationIds] = useState([]);
  const navigate = useNavigate();

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [localities, setLocalities] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState("");
  const [date, setDate] = useState("")
  const [noOfProperty, setNoOfProperty] = useState(0)
  const [amount, setAmount] = useState(0)
  const [remarks, setRemarks] = useState("")

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      console.log("HYT31", res.data);

      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find(item => item._id === userCity)])
          setSelectedCity(userCity)
          fetchLocalities(userCity)
        } else {
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  }

  // Fetch localities
  const fetchLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();
      console.log("HYT71", res);

      if (res?.data) {
        setLocalities(res.data.filter((item) => item?.city?._id === cityId));
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const usersResponse = await HomeService.getUsers();
        const citiesResponse = await HomeService.getCities();

        // console.log("POI77",usersResponse.data);


        if (userCity) {
          setUserList(usersResponse.data.filter(item => item?.city._id === userCity))
        } else {
          setUserList(usersResponse?.data || []);
        }
        setCityList(citiesResponse?.data || []);
      } catch (error) {
        toast.error("Failed to fetch user or city list.");
        console.error("Error fetching data:", error);
      }
    };
    fetchData();

    // Close dropdown if clicked outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    // Close dropdown if clicked outside
    const handleClickLocationOutside = (event) => {
      if (dropdownLocationRef.current && !dropdownLocationRef.current.contains(event.target)) {
        setIsDropdownLocationOpen(false);
      }
    };



    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("mousedown", handleClickLocationOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("mousedown", handleClickLocationOutside);
    };


  }, []);

  useEffect(() => {
    fetchCities();
  }, [])

  useEffect(() => {
    fetchLocalities(selectedCity)
  }, [selectedCity])

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      userId,
      cityId: [selectedCity],
      locality: locationIds,
      price: parseInt(amount),
      date: date.split("T")[0],
      remarks: remarks,
      addedBy: loggedUserID,
      noOfProperty:noOfProperty,
    };

    console.log("KIU150", data);
    // return


    try {
      const res = await HomeService.addInventory(data);

      if (res?.status) {
        toast.success("Inventory added successfully!");
        clearForm();
        navigate("/manage-inventory"); // Replace with appropriate route
      }
    } catch (error) {
      toast.error("Failed to add Inventory.");
      console.error("Error adding Inventory:", error);
    }
  };

  const clearForm = () => {
    setUserId("");
    setCityIds([]);
    setStartDate("");
    setEndDate("");
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setCityIds(
      (prevCities) =>
        prevCities.includes(value)
          ? prevCities.filter((_id) => _id !== value) // Remove if already selected
          : [...prevCities, value] // Add if not selected
    );
  };

  const handleLocationChange = (e) => {
    const value = e.target.value;
    setLocationIds(
      (prev) =>
        prev.includes(value)
          ? prev.filter((_id) => _id !== value) // Remove if already selected
          : [...prev, value] // Add if not selected
    );
  };

  const [allSelected, setAllSelected] = useState(false)
    const handleSelectAllLocations = (e) => {
      console.log("JUY189", localities, locationIds, e.target.value);
      let allLocalities = localities.map(item => item._id);
      if (allSelected) {
        allLocalities = []
      }
      setLocationIds(allLocalities)
      setAllSelected(!allSelected)
    };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen); // Toggle dropdown visibility
  };

  const toggleDropdownLocation = () => {
    setIsDropdownLocationOpen(!isDropdownLocationOpen); // Toggle dropdown visibility
  };

  const formatDateForDisplay = (date) => {
    if (!date) return ""; // Handle empty or invalid dates
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add Inventory
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label htmlFor="user">
                    User<span className="text-danger">*</span>
                  </label>
                  <select
                    id="user"
                    className="form-control"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    required
                  >
                    <option value="">Select User</option>
                    {userList.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.fullName}-<h6>{user.email}</h6>
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Price<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="amount"
                    className="form-control"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="cities">
                    Cities<span className="text-danger">*</span>
                  </label>
                  {/* <div className="dropdown" ref={dropdownRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdown}
                    >
                      {cityIds.length === 0
                        ? "Select Cities"
                        : `${cityIds.length} cities selected`}
                    </button>
                    {isDropdownOpen && (
                      <div className="dropdown-menu-for-city">
                        {cityList.map((city) => (
                          <div key={city._id} className="form-check">
                            <input
                              type="checkbox"
                              id={`city-${city._id}`} // Properly linking with label
                              value={city._id}
                              checked={cityIds.includes(city._id)}
                              onChange={handleCityChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={`city-${city._id}`} // Linking label to input for accessibility
                              className="form-check-label"
                            >
                              {city.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div> */}
                  <select
                    className="form-control"
                    value={selectedCity}
                    onChange={(e) => {
                      setSelectedCity(e.target.value)
                      setAllSelected(false)
                      setLocationIds([])
                    }}
                  >
                    <option value="" disabled>---Select---</option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>


                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Locality<span className="text-danger">*</span>
                  </label>
                  {/* <select
                    className="form-control"
                    value={selectedLocality}
                    onChange={(e) => setSelectedLocality(e.target.value)}
                  >
                    <option value="" disabled>---Select---</option>
                    {localities.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select> */}

                  <div className="dropdown" ref={dropdownLocationRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdownLocation}
                    >
                      {locationIds.length === 0
                        ? "Select Locations"
                        : `${locationIds.length} locations selected`}
                    </button>
                    {isDropdownLocationOpen && (
                      <div className="dropdown-menu-for-city">
                        {
                          localities.length > 0 &&
                          <div className="form-check"
                            style={{
                              borderBottom: "solid 1px #eee"
                            }}
                          >
                            <input
                              type="checkbox"
                              id="s_all" // Properly linking with label
                              value="all"
                              checked={allSelected}
                              onChange={handleSelectAllLocations}
                              className="form-check-input"
                            />
                            <label
                              className="form-check-label"
                            >
                              Select all
                            </label>
                          </div>
                        }
                        {localities.map((item) => (
                          <div key={item._id} className="form-check">
                            <input
                              type="checkbox"
                              id={`city-${item._id}`} // Properly linking with label
                              value={item._id}
                              checked={locationIds.includes(item._id)}
                              onChange={handleLocationChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={`city-${item._id}`} // Linking label to input for accessibility
                              className="form-check-label"
                            >
                              {item.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                {/* </div> */}

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    className="form-control"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Number of Properties
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={noOfProperty}
                    onChange={(e) => setNoOfProperty(e.target.value)}
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="endDate">
                    Remarks
                  </label>

                  <textarea
                    className="form-control"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder="Enter remarks (if any)"
                  ></textarea>
                </div>
              </div>


              <button type="submit" style={{
                background: 'rgb(133, 218, 79)',
                borderRadius: '13px'
              }} className="btn mt-3">
                Add Inventory
              </button>
              <button type="submit" style={{
                background: '#fff',
                border:"solid 2px #85da4f",
                borderRadius: '13px',
                margin:'0 10px'
              }} className="btn mt-3"
                onClick={()=>{ navigate("/manage-inventory")} }
              >
                View Inventory
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddInventory;
